// Reusable date formatting with ordinal suffix
// Input: date string or Date
// Output: '5th Aug 2025'
export function formatArticleDate(value: string | Date, locale: string = 'en-US'): string {
  try {
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return typeof value === 'string' ? value : '';
    const dayNum = d.getDate();
    const suffix = (n: number) => {
      if (n >= 11 && n <= 13) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
    const day = `${dayNum}${suffix(dayNum)}`;
    const month = d.toLocaleString(locale, { month: 'short' });
    const year = d.getFullYear();
    return `${day} ${month}, ${year}`;
  } catch {
    return typeof value === 'string' ? value : '';
  }
}
